import type { TefComs4csMicroFrontend } from '@mfe-4cs/components/tef-coms4cs';
import { TemplateResult, html, nothing } from 'lit';
import {
  FeatureValue, HistoryConsentItem, HistoryItem, PredecessorItem,
} from '@mfe-4cs/types/comsApi';
import { featuresTypes } from '@mfe-4cs/defs/featureTypes';
import comsStore from '@mfe-4cs/state/ComsStore';
import { localDate, localTime } from '../util';

const labelTmpl = (granted: boolean) => {
  const iconName = granted ? 'check' : 'cancel';
  const color = granted ? 'positive' : 'warning';
  const text = granted ? 'Zustimmung' : 'Widerspruch';

  return html`
    <one-list-item size="sm">
      <one-icon name="${iconName}" variant="outline" color="${color}" slot="icon"></one-icon>
      <one-text as="p" strong color="${color}">
        ${text}
      </one-text>
    </one-list-item>
  `;
};

const featureTmpl = (feature: FeatureValue) => html`
  <one-text as="div">
    ${feature.title}
    ${labelTmpl(!!feature.granted)}
  </one-text>
`;

// eslint-disable-next-line sonarjs/function-return-type
const predeseccorsTemplate = (predecessors?: PredecessorItem[]) => {
  if (!predecessors) {
    return nothing;
  }

  return html`
    <one-text as="div">
      Vorgänger: ${predecessors.map(({ id, name }, ind) => html`
        ${ind > 0 ? ' und ' : nothing}
        <one-link
          role="button"
          @click=${() => { /* eslint-disable @typescript-eslint/indent */
            comsStore.history!.configId = id;
          } /* eslint-enable @typescript-eslint/indent */}
        >
          ${name}
        </one-link>
      `)}
    </one-text>
  `;
};

const historyConsentItem = (coms: HistoryConsentItem): TemplateResult => {
  const existingFeatureName = featuresTypes.find((fn) => !!coms[fn]);

  const feats = existingFeatureName ? coms[existingFeatureName] : [];

  return html`
    ${labelTmpl(coms.granted)}
    <one-stack gap="sm">${feats!.map(featureTmpl)}</one-stack>
    <one-list-item size="sm">
      <one-icon name="clock" variant="outline" slot="icon" context="selfcare selfcare" ></one-icon>
      Geändert von ${coms.meta.usertype}: ${coms.meta.username} über ${coms.meta.channelDisplay};  Version ${coms.version}
      ${predeseccorsTemplate(coms.meta.predecessors)}
    </one-list-item>
  `;
};

export function historyItemTemplate(this: TefComs4csMicroFrontend, item: HistoryItem): TemplateResult {
  return html`
    <one-stack gap="sm">
      <one-text as="p" size="lg" strong>
        ${localDate(item.actionDate)} ${localTime(item.actionDate)}
      </one-text>
      ${item.consents.map(historyConsentItem)}
    </one-stack>
  `;
}
